/*
 *
 * EditTerminalPopup
 *
 * @version 1.0.0
 * @author Andrea Pinardi
 * @since 13-Jan-2025
 */

import EditTerminalPopup from './EditTerminalPopupContainer'

export default EditTerminalPopup
